import styled from "styled-components";


export const Overlay = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1400;

  @media (max-width: 765px) {
    align-items: flex-end;
    padding: 0 12px;
  }
`;


export const ModalWrapper = styled.div`
  width: 922px;
  max-width: 90%;
  background-color: white;
  border-radius: 8px;
  position: relative;
  padding: 30px;

  @media (max-width: 1024px) {
    width: 90%;
    padding: 32px;
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    height: 90vh;
    padding: 24px;
    border-radius: 16px 16px 0 0;
    overflow-y: auto;
  }

  @media (max-width: 480px) {
    padding: 20px 16px;
  }
`;


export const Container = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 20px;
  position: relative;

  @media (max-width: 768px) {
    gap: 16px;
  }
`;


export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
`;

export const CloseIcon = styled.img`
  cursor: pointer;
  width: 24px;
  height: 24px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 28px;
    height: 28px;
  }
`;


export const Title = styled.h1`
  font-family: IBM Plex Sans;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 26px;
  }
`;


export const SubTitle = styled.h2`
  font-family: IBM Plex Sans;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #3f3b43;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 26px;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;


export const Message = styled.p`
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: rgba(86, 81, 91, 1);
  margin: 0;

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 20px;
  }
`;
export const RequestClassChangeButton = styled.button`
  width: 191px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;

  padding: 8px 16px;

  border: 1px solid #2E2177;
  border-radius: 900px;

  background: transparent;
  color: #2E2177;

  font-family: "IBM Plex Sans", sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  white-space: nowrap;

  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #F5F3FF;
  }

  &:active {
    transform: scale(0.98);
  }
`;
export const StudentBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  padding: 8px;

  border: 1px solid var(--color-neutral-90, #C9C6CC);
  border-radius: 12px;

  opacity: 1;

  span {
    display: flex;       
    align-items: center;  
    line-height: 1;       
  }
`;
